var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'mobile')?_c('MobileLayerEditor',[_vm._t("default")],2):_c('ScreenLayerEditor',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }